import { useState, useRef } from "react";

import { useDispatch, useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";

import { sendEmail } from "../../../../helpers/sendEmail";

import { setResultObject } from "../../../../store/reducers/FormReducer";
import { checkAllValues } from "../helpers/checkers";

export const useSendButton = (inputs, sendInfo, analysis) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sendingForm = useRef(null);

  const { resultObject } = useSelector((state) => state.form);

  const [isOpen, setIsOpen] = useState(false);
  const [isSending, setIsSending] = useState(false);

  const open = () => {
    if (checkAllValues(inputs)) {
      const resultObject = analysis(inputs);
      dispatch(setResultObject(resultObject));
      setIsOpen(true);
    } else {
      alert("Заполните все поля");
    }
  };

  const send = async () => {
    if (isSending) return; // блокировка повторной отправки
    setIsSending(true);
    const { testName, noRedirect, redirectTo } = sendInfo || {};

    // Найти ФИО из inputs (ищем первый input с type: 'bottomInput' и text: 'ФИО' или id: 0)
    let fio = '';
    const fioInput = inputs.find(
      (input) =>
        (input.type === 'bottomInput' && (input.text?.toLowerCase().includes('фио') || input.id === 0))
    );
    if (fioInput && fioInput.value) {
      fio = fioInput.value;
    }

    try {
      const directusSendInfo = {
        provider: "directus_flow",
        baseUrl: "https://crm-hr.kzn.ru",
        flowId: "9c0df71d-3ceb-4ab4-aa0c-a6806f3d89a6",
        token: "sGaLAYCUxT_HpfAaMiQNb4qzieuAtUAM",
        subjectPrefix: process.env.REACT_APP_DIRECTUS_SUBJECT_PREFIX || "HR Tests",
      };
      await sendEmail(undefined, testName || "", fio, resultObject.result, undefined, directusSendInfo);
      setIsSending(false);
      close();
      if (!noRedirect) {
        navigate(redirectTo || "/finish");
      }
    } catch (error) {
      console.log(error);
      setIsSending(false);
      alert('Ошибка отправки: ' + (error?.message || 'неизвестная ошибка'));
    }
  };

  const close = () => {
    setIsOpen(false);
  };

  const formInputs = [
    {
      id: 0,
      name: "name",
      value: resultObject.name,
    },
    {
      id: 1,
      name: "result",
      value: resultObject.result,
    },
  ];

  return {
    isOpen,
    open,
    send,
    close,
    sendingForm,
    formInputs,
    isSending,
  };
};
